import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("users", [], router);

export const usersService = {
  ...baseService,
  list: (params) => api.getCall("/api/users", params),
  getById: (id) => api.getCall(`/api/users/${id}`),
  getPreferences: async () => {
    return api.getCall("/api/users/preferences");
  },
  updatePreferences: async (data) => {
    return api.putCall("/api/users/preferences", data);
  },
};

export default usersService;
